import { useLocation } from "react-router";
import { useSearchParams } from "react-router";

export const useActiveTab = (): {
  activeTabName: string;
  generateActiveTabUrl: (params: { url?: string; name?: string }) => string;
} => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const activeTabName = searchParams.get("tab") ?? "";

  const generateActiveTabUrl = ({
    url,
    name,
  }: {
    url?: string;
    name?: string;
  }): string => {
    const tabName = name || activeTabName;
    const path = url || location.pathname;
    return `${path}?tab=${tabName}`;
  };

  return {
    activeTabName,
    generateActiveTabUrl,
  };
};
